import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

const BookEvent = () => {
  // Scroll to top on mount + load Tally embed script for dynamic height
  useEffect(() => {
    window.scrollTo(0, 0);

    const script = document.createElement('script');
    script.src = 'https://tally.so/widgets/embed.js';
    script.async = true;
    script.onload = () => {
      if (typeof window.Tally !== 'undefined') {
        window.Tally.loadEmbeds();
      }
    };
    document.body.appendChild(script);

    return () => {
      if (script.parentNode === document.body) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="home-page" data-testid="book-event-page">
      <Header />

      <section className="section" style={{ paddingTop: '8rem', minHeight: '70vh' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto 1.5rem' }}>
          <Link
            to="/"
            className="back-link"
            data-testid="back-to-home-link"
          >
            <ArrowLeft size={18} />
            <span>Back to home</span>
          </Link>
        </div>

        <div className="section-header">
          <h1 className="heading-1 section-title">Get a Quote</h1>
          <p className="body-large section-subtitle">
            Tell us about your event and we&rsquo;ll send over a custom quote, usually within 24 hours. Be sure to complete all fields and submit at the bottom of the form.
          </p>
        </div>

        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <iframe
            data-tally-src="https://tally.so/embed/3EjBx2?hideTitle=1&transparentBackground=1&dynamicHeight=1"
            width="100%"
            height="500"
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
            title="Book Your Event"
            style={{ border: 'none', background: 'transparent' }}
            data-testid="booking-tally-iframe"
          ></iframe>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BookEvent;
